import React, { useState, useEffect, useCallback } from "react"
import { Link } from "react-router-dom"
import { authFetch, buildQuery } from "../../lib/api"

function formatDate(d) {
  if (!d) return "Not provided"
  return new Date(d).toLocaleString(undefined, { dateStyle: "short", timeStyle: "short" })
}

function trimMessage(message) {
  if (!message) return "No message"
  return message.length > 90 ? `${message.slice(0, 90)}...` : message
}

export default function AdminContactSubmissions() {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [filterSource, setFilterSource] = useState("")

  const load = useCallback(() => {
    setError("")
    const q = buildQuery({ page: 1, limit: 100, source: filterSource || undefined })
    authFetch(`/api/admin/contact-submissions${q}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.error) setError(data.error)
        else setList(data.contactSubmissions || [])
      })
      .catch(() => setError("Failed to load submissions"))
      .finally(() => setLoading(false))
  }, [filterSource])

  useEffect(() => {
    load()
  }, [load])

  return (
    <section className='dashboard-card'>
      <div className='dashboard-card__header'>
        <div>
          <span className='dashboard-eyebrow'>Inbox</span>
          <h2>Contact and inquiry submissions</h2>
          <p>Read contact form and listing inquiry submissions from visitors.</p>
        </div>
      </div>

      {error && <p className='dashboard-error'>{error}</p>}

      <div className='admin-toolbar'>
        <select value={filterSource} onChange={(e) => setFilterSource(e.target.value)}>
          <option value=''>All sources</option>
          <option value='contact'>Contact</option>
          <option value='inquiry'>Inquiry</option>
        </select>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : list.length === 0 ? (
        <div className='dashboard-empty'>No submissions.</div>
      ) : (
        <div className='admin-table-wrap'>
          <table className='admin-table'>
            <thead>
              <tr>
                <th>Date</th>
                <th>Source</th>
                <th>Name</th>
                <th>Email</th>
                <th>Subject / Listing</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              {list.map((row) => (
                <tr key={row.id}>
                  <td className='admin-table__muted'>{formatDate(row.createdAt)}</td>
                  <td><span className='admin-role-pill'>{row.source}</span></td>
                  <td><strong>{row.name}</strong></td>
                  <td><a href={`mailto:${row.email}`}>{row.email}</a></td>
                  <td>
                    {row.source === "inquiry" && row.listingId ? (
                      <Link to={`/listings/${row.listingId}`}>Listing</Link>
                    ) : (
                      <span className='admin-table__muted'>{row.subject || "Not provided"}</span>
                    )}
                  </td>
                  <td className='admin-table__message'>{trimMessage(row.message)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
